"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = require("prop-types");

var index_1 = require("../../index");

require("./index.css");

var CharacterCount = function (_a) {
  var value = _a.value,
      maxLength = _a.maxLength,
      testId = _a.testId;
  var textLength = !value ? 0 : value.length;

  var counterText = function () {
    if (textLength === 1) {
      return '1 Character';
    }

    return textLength + " Characters";
  };

  var overageCount = function () {
    var overage = !Number.parseInt(maxLength) ? -1 : textLength - maxLength;
    return overage > 0 ? "| " + (textLength - maxLength) + " over suggested" : '';
  };

  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: "character-count-container"
  }, {
    children: [(0, jsx_runtime_1.jsx)(index_1.Icon, {
      name: "information",
      className: "fill icon-yellow character-count-alert",
      width: 16
    }, void 0), ' ', (0, jsx_runtime_1.jsx)("span", __assign({
      "data-testid": "count-for-" + testId
    }, {
      children: counterText() + " " + overageCount()
    }), void 0)]
  }), void 0);
};

CharacterCount.propTypes = {
  value: prop_types_1.string,
  maxLength: prop_types_1.number,
  testId: prop_types_1.string
};
CharacterCount.defaultProps = {
  value: '',
  maxLength: null,
  testId: ''
};
exports.default = CharacterCount;